import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { Select } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';

export interface ControlledSelectProps<T extends FieldValues> {
  allOption?: boolean;
  control: Control<T>;
  disabled?: boolean;
  label: string;
  name: Path<T>;
  options: Array<SelectOption<string>>;
  rules?: object;
  size?: 'small' | 'medium' | 'large';
  testId?: string;
}

export const ControlledSelect = <T extends FieldValues>({
  allOption = false,
  control,
  disabled = false,
  label,
  name,
  options,
  rules = {},
  size = 'small',
  testId = 'controlled-select'
}: ControlledSelectProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Select
          allOption={allOption}
          disabled={disabled}
          label={label}
          options={options}
          value={field.value || ''}
          onChange={(selected) => field.onChange(selected.value)}
          size={size}
          testId={testId}
        />
      )}
    />
  );
};
